export default __webpack_public_path__ + "static/media/customizable-close-button.4c8d3caa.svg";